import { Map as ImmutableMap } from 'immutable';
import { createAction } from 'redux-actions';

import { rootUiActions, rootUiTypes } from 'app-components/flux/root-ui';
import store from 'app-components/utils/redux-store';

import type { BusinessIncomeDeductionsModalProps } from './types';

export const BUSINESS_INCOME_DEDUCTIONS_MODAL = 'BUSINESS_INCOME_DEDUCTIONS_MODAL';

export const businessIncomeDeductionsModalAction = createAction(
  rootUiActions.createDialog.toString(),
  (props: BusinessIncomeDeductionsModalProps) =>
    rootUiTypes.mkRootUiData({
      type: BUSINESS_INCOME_DEDUCTIONS_MODAL,
      props: ImmutableMap({
        ...props,
        title: props?.title || 'Taxable Business Profit',
        modalType: props?.modalType || 'drawer',
      }),
    }),
);

export const dispatchBusinessIncomeDeductionsModal = (props: BusinessIncomeDeductionsModalProps) =>
  store?.dispatch(businessIncomeDeductionsModalAction(props));
export default dispatchBusinessIncomeDeductionsModal;
